import { Get } from "./ApiBase";

export async function GetStyle() {
  return await Get("/api/GetEnvStyle");
}